<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-select
        :items="items"
        return-object
        item-text="nazev"
        v-model="selectedItem"
        label="Dodavatel"
        :hide-details="hideDetails"
        :outline="outline"
        class="mx-2"
        :rules="rules"
        :disabled="disabled"
      >
      </v-select>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [],
      selectedItem: null
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Number,
    all: Boolean,
    disabled: Boolean,
    selectFirst: Boolean
  },
  watch: {
    selectedItem (v) {
      this.$emit("changed", v);
      this.$emit("input", v.id);
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      window.api.get("dodavatele/search").then(function(_body) {
        this.items = this.all ? [ { id: null, nazev: "Vše" } ].concat(_body.data) : _body.data;
        if (this.value != null) {
          var $value = this.value;
          var $f = this.items.filter((x) => { return x.id == $value; });
          if ($f.length > 0)
            this.selectedItem = $f[0];
          else
            this.selectedItem = null;
        }
        else {
          this.selectedItem = this.all || this.selectFirst ? this.items[0] : null;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Dodavatele.vue